import { getCheckoutSessionFlags, logger, STATE_NAME } from '@/lib';
import type { AuthEventName } from './authEventHandler';

const fptiDefaults = () => {
  const { isGuestEligible } = getCheckoutSessionFlags();
  return {
    account_signup_type: isGuestEligible ? 'guest' : 'signup',
    state_name: STATE_NAME.billing,
  };
};

export const pageShown = (): void => {
  const eventName = 'passkey_page_shown';

  logger.fpti(eventName, {
    ...fptiDefaults(),
    event_name: eventName,
    transition_name: 'process_passkey_page_shown',
  });
};

export const passkeyEnrollmentButtonShown = (): void => {
  const eventName = 'passkey_enrollment_button_shown';

  logger.fpti(eventName, {
    ...fptiDefaults(),
    event_name: eventName,
    transition_name: 'process_passkey_enrollment_button_shown',
  });
};

export const passkeyDisplayIWCTriggered = (): void => {
  const eventName = 'passkey_button_display_triggered';

  logger.fpti(eventName, {
    ...fptiDefaults(),
    event_name: eventName,
    transition_name: 'process_passkey_button_display_triggered',
  });
};

export const passkeyEnrollmentSuccess = (): void => {
  const eventName = 'passkey_enrollment_success';

  logger.fpti(eventName, {
    ...fptiDefaults(),
    event_name: eventName,
    transition_name: 'process_passkey_enrollment_success',
  });
};

export const passkeyBeforeUnload = (): void => {
  const eventName = 'passkey_beforeunload_triggered';

  logger.fpti(eventName, {
    ...fptiDefaults(),
    event_name: eventName,
    transition_name: 'process_beforeunload_triggered',
  });
};

export const passkeyErrorShown = ({
  errorCode,
  errorDescription,
}: {
  errorCode: string | undefined;
  errorDescription: string | undefined;
}): void => {
  const eventName = 'passkey_error_alert_shown';

  logger.fpti(eventName, {
    ...fptiDefaults(),
    event_name: eventName,
    int_error_code: errorCode ?? 'unknown',
    int_error_description: errorDescription ?? '',
    transition_name: 'process_passkey_error_alert_shown',
  });
};

export const passkeyAuthEvent = (
  authEventName: AuthEventName,
  wasFailure?: boolean,
): void => {
  const eventName = wasFailure
    ? 'passkey_auth_event_failure_received'
    : 'passkey_auth_event_received';

  logger.fpti(eventName, {
    ...fptiDefaults(),
    event_name: eventName,
    transition_name: `process_${authEventName}`,
  });
};
